import {call, put, select, takeEvery,} from 'redux-saga/effects';

import {push} from 'connected-react-router';

import {AUTHENTICATE_USER, GET_USER_DATA_REQUESTED, USER_LOGOUT_REQUEST,} from './actionTypes';
import {getUserDataFailed, getUserDataSucceeded,} from './action';
import {destroyChat} from '../chat/action';
import {fetchUser, getUserContact, logOutUser as logOutRequest} from './api';
import {getUser} from '../sagaUtils';
import {addNotification} from '../notification/action';


import config from '../../config';
import {getUserByEmail} from "../company/api";

function* authenticateUser() {
    try {
        yield put(push('/dashboard'));
    } catch (error) {
        yield put(addNotification('somethingWentWrong', config.notificationLevels.error, {}));
    }
}

function* logoutUser() {
    logOutRequest().then(() => window.location.href = "/login");
    yield put(destroyChat());
}

function* getUserData() {
    try {
        const userTokenInitializedData = yield select(getUser);
        let userData = yield call(fetchUser, userTokenInitializedData.id);

        let user;
        try {
            user = yield call(() => getUserByEmail(userData.email));
        } catch (err) {
            if (err.response && err.response.status === 500) {
                document.cookie = "jwt-access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                window.location.href = '/login';
                return;
            } else {
                throw err;
            }
        }

        userData = { ...user, ...userData };
        userData.postgresId = user.id

        yield call(getUserContact, userTokenInitializedData.id, userTokenInitializedData.companyId);
        yield put(getUserDataSucceeded(userData));
    } catch (e) {
        yield put(getUserDataFailed(e));
    }
}


function* watchUser() {
    yield takeEvery(AUTHENTICATE_USER, authenticateUser);
    yield takeEvery(USER_LOGOUT_REQUEST, logoutUser);
    yield takeEvery(GET_USER_DATA_REQUESTED, getUserData);
}


export default watchUser;



// WEBPACK FOOTER //
// ./src/services/user/saga.js